var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useMutation } from "react-query";
import { PvsApi } from "@jti/rest-api";
export const usePhoneService = () => {
    const callVerifyOtp = useMutation("verifyOtp", ({ phoneVerificationUuid, code }) => PvsApi.init().verifyOtp(phoneVerificationUuid, code));
    const verifyOtp = useCallback((phoneVerificationUuid, code) => __awaiter(void 0, void 0, void 0, function* () { return yield callVerifyOtp.mutateAsync({ phoneVerificationUuid, code }); }), [callVerifyOtp]);
    const callVerifyEmailOtp = useMutation("verifyEmailOtp", ({ uuid, code }) => PvsApi.init().verifyEmailOtp(uuid, code));
    const verifyEmailOtp = useCallback((uuid, code) => __awaiter(void 0, void 0, void 0, function* () { return yield callVerifyEmailOtp.mutateAsync({ uuid, code }); }), [callVerifyEmailOtp]);
    const checkValidationStatusMutation = useMutation("checkValidationStatus", ({ uuid, hash }) => PvsApi.init().checkVerificationStatus(uuid, hash));
    const checkValidationStatus = useCallback((uuid, hash) => __awaiter(void 0, void 0, void 0, function* () { return yield checkValidationStatusMutation.mutateAsync({ uuid, hash }); }), [checkValidationStatusMutation]);
    const initPhoneValidationByOtpMutation = useMutation("initPhoneValidationByOtp", (phone) => PvsApi.init().initPhoneValidationByOtp(phone));
    const initPhoneValidationByOtp = useCallback((phone) => __awaiter(void 0, void 0, void 0, function* () { return yield initPhoneValidationByOtpMutation.mutateAsync(phone); }), [initPhoneValidationByOtpMutation]);
    return {
        verifyOtp,
        verifyEmailOtp,
        isVerifyEmailOtpLoading: callVerifyEmailOtp.isLoading,
        checkValidationStatus,
        initPhoneValidationByOtp,
        isVerifyOtpLoading: callVerifyOtp.isLoading,
        isVerifyOtpFailed: callVerifyOtp.isError,
    };
};
